export default __webpack_public_path__ + "static/media/dog3.9a11d111.png";